export default __webpack_public_path__ + "static/media/girl.a69d861e.svg";